import { ChevronLeft, ChevronRight } from 'lucide-react';
import styles from './Pagination.module.css';

function getPageWindow(page, totalPages) {
  const delta = 2;
  const range = [];

  const left  = Math.max(2, page - delta);
  const right = Math.min(totalPages - 1, page + delta);

  range.push(1);
  if (left > 2)          range.push('...');
  for (let i = left; i <= right; i++) range.push(i);
  if (right < totalPages - 1) range.push('...');
  if (totalPages > 1)    range.push(totalPages);

  return range;
}

function Pagination({ page, totalPages, onPageChange, variant = 'outline' }) {
  if (totalPages <= 1) return null;
  const window = getPageWindow(page, totalPages);

  return (
    <div className={`${styles.pagination} ${styles[variant]}`}>
      <button
        className={`${styles.btn} ${styles.nav}`}
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
      >
        <ChevronLeft size={14} /> Previous
      </button>

      {window.map((n, i) =>
        n === '...' ? (
          <span key={`ellipsis-${i}`} className={styles.ellipsis}>…</span>
        ) : (
          <button
            key={n}
            className={`${styles.btn} ${styles.num} ${page === n ? styles.active : ''}`}
            onClick={() => onPageChange(n)}
          >
            {n}
          </button>
        )
      )}

      <button
        className={`${styles.btn} ${styles.nav}`}
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        Next <ChevronRight size={14} />
      </button>
    </div>
  );
}

export default Pagination;
